export const wide = "@media screen and (min-width: 850px)";
export const sidePadding = 30;
